var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-logo m-0",on:{"click":_vm.redirectToLogin}},[(_vm.isLink)?_c('router-link',{staticClass:"mt-logo__link block",class:_vm.customSize,attrs:{"to":"/"}},[_c('img',{staticClass:"w-full lg:max-h-10",attrs:{"src":_vm.logoSrc}})]):_c('img',{staticClass:"w-full lg:max-h-10",class:_vm.customSize,attrs:{"src":_vm.logoSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }